// Tipos e rótulos do módulo Sub-usuários (delegação de acesso) — porte do
// legado SGT.Modules/PortalContribuinte/Modules/SubUsuarios. Espelham o contrato
// EXATO do backend novo (apps/backend-portal/src/usuario/subusuarios-routes.ts):
// o módulo NUNCA lida com senha — o POST apenas VINCULA um usuário já cadastrado
// (localizado por CPF/CNPJ) à empresa do contribuinte logado.

// Chave da lista/SWR e base dos endpoints (todos sob o prefixo /portal-api).
export const SUB_USUARIOS_KEY = '/portal-api/usuario/sub-usuarios';

// PermissoesDto do legado — 11 flags booleanas do vínculo (SubUsuariosDtos.cs).
export interface PermissoesSubUsuario {
  emitirNfse: boolean;
  corrigirNfse: boolean;
  cancelarNfse: boolean;
  encerrarLivros: boolean;
  reabrirLivros: boolean;
  emitirGuias: boolean;
  cancelarGuias: boolean;
  alterarContatos: boolean;
  alterarSenha: boolean;
  acessoCliente: boolean;
  acessoContaFiscal: boolean;
}

export type PermissaoChave = keyof PermissoesSubUsuario;

// SubUsuarioListDto: tipo = CONTADOR quando tomadorset.contador, senão CONVENCIONAL.
export interface SubUsuario {
  id: number;
  nome: string;
  cpfCnpj: string;
  tipo: 'CONTADOR' | 'CONVENCIONAL';
  ativo: boolean;
  permissoes: PermissoesSubUsuario;
}

// Envelope do GET /usuario/sub-usuarios.
export interface SubUsuariosResposta {
  subUsuarios: SubUsuario[];
}

// Rótulos pt-BR das 11 permissões, na ordem do PermissoesDto do legado.
export const PERMISSOES_DEF: Array<{ chave: PermissaoChave; label: string }> = [
  { chave: 'emitirNfse', label: 'Emitir NFS-e' },
  { chave: 'corrigirNfse', label: 'Corrigir NFS-e' },
  { chave: 'cancelarNfse', label: 'Cancelar NFS-e' },
  { chave: 'encerrarLivros', label: 'Encerrar livros' },
  { chave: 'reabrirLivros', label: 'Reabrir livros' },
  { chave: 'emitirGuias', label: 'Emitir guias' },
  { chave: 'cancelarGuias', label: 'Cancelar guias' },
  { chave: 'alterarContatos', label: 'Alterar contatos' },
  { chave: 'alterarSenha', label: 'Alterar senha' },
  { chave: 'acessoCliente', label: 'Acesso cliente' },
  { chave: 'acessoContaFiscal', label: 'Acesso à conta fiscal' },
];

// Todas as permissões em false — default do formulário de criação.
export function permissoesVazias(): PermissoesSubUsuario {
  return {
    emitirNfse: false,
    corrigirNfse: false,
    cancelarNfse: false,
    encerrarLivros: false,
    reabrirLivros: false,
    emitirGuias: false,
    cancelarGuias: false,
    alterarContatos: false,
    alterarSenha: false,
    acessoCliente: false,
    acessoContaFiscal: false,
  };
}

export function limparCpfCnpj(doc: string): string {
  return (doc ?? '').replace(/\D/g, '');
}

// Máscara de CPF (11) ou CNPJ (14); devolve o valor original se não bater.
export function formatCpfCnpj(doc: string): string {
  const digits = limparCpfCnpj(doc);
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return doc;
}

export function getTipoLabel(tipo: SubUsuario['tipo']): string {
  return tipo === 'CONTADOR' ? 'Contador' : 'Convencional';
}
